module.exports = __webpack_public_path__ + "img/N550-1.e64d06a7.png";